var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.data)?_c('el-tree',{attrs:{"data":_vm.buildTree(_vm.data),"node-key":"Id","default-expand-all":"","props":{
        children: 'Nodes',
        label: 'Name',
    }},scopedSlots:_vm._u([{key:"default",fn:function({ node, data }){return _c('span',{},[_c('span',{class:_vm.getTreeNodeClass(node, data),style:(_vm.getTreeNodeStyle(node, data))},[_vm._v(_vm._s(node.label))])])}}],null,false,2047426126)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }